<template>
  <div id="adds">
    <div id="addsLeft"><vueDrag ref="vueDrag"></vueDrag></div>
    <div id="addsRight">
      <comMap ref="map"></comMap>
    </div>
  </div>
</template>
<script>
import vueDrag from "./vueDrag.vue";
export default {
  components: { vueDrag },
  data() {
    return {};
  },
  methods: {
    reach(v) {
      this.$refs.vueDrag.reach(v);
      var m = [];
      var n = [
        {
          nn: 1,
          pointList: [
            {
              x: 113.12,
              y: 22.43,
            },
            {
              x: 113.14,
              y: 22.46,
            },
            {
              x: 113.18,
              y: 22.41,
            },
          ],
        },
      ];
      setTimeout(() => {
        this.$refs.map.showlines(n);
      }, 2000);
      
    },
  },
};
</script>
<style>
#adds {
  width: 100%;
  height: 100%;
  display: flex;
}
#adds #addsLeft {
  width: 200px;
  height: 100%;
}
#adds #addsRight {
  width: calc(100% - 200px);
  height: 100%;
  background: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/paisong/adds.vue